import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  class: "icon flat-color",
  "data-name": "Flat Color",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m20.91 17.5.8-.79a1 1 0 0 0-1.42-1.42l-.79.8-.79-.8a1 1 0 0 0-1.42 1.42l.8.79-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l.79-.8.79.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM6 7a5 5 0 1 1 5 5 5 5 0 0 1-5-5m8 7H8a6 6 0 0 0-6 6 2 2 0 0 0 2 2h10a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1" }, null, -1)
  ])))
}
export default { render: render }